<div class="location-search-container" style="display: flex; flex-direction: column;">
    <div>
        <div class="search-title">{{title}}</div>
        <div class="search-description">{{searchByText}}</div>
        
        <form [formGroup]="locationSearchForm" (ngSubmit)="onSubmit()">
            <div class="search-input-container">
                <div class="input-with-icon">
                    <span class="search-icon">
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.16668 2.06778C5.12911 2.06778 2.66668 4.57195 2.66668 7.661C2.66668 10.75 5.12911 13.2542 8.16668 13.2542C11.2042 13.2542 13.6667 10.75 13.6667 7.661C13.6667 4.57195 11.2042 2.06778 8.16668 2.06778ZM0.833344 7.661C0.833344 3.54226 4.11659 0.203369 8.16668 0.203369C12.2168 0.203369 15.5 3.54226 15.5 7.661C15.5 9.38437 14.9252 10.9712 13.9599 12.2341L18.8982 17.2561C19.2562 17.6201 19.2562 18.2104 18.8982 18.5744C18.5402 18.9384 17.9598 18.9384 17.6018 18.5744L12.6635 13.5524C11.4217 14.5341 9.86133 15.1186 8.16668 15.1186C4.11659 15.1186 0.833344 11.7797 0.833344 7.661Z" fill="#0D0D0D"/>
                        </svg>
                    </span>
                    <input 
                        type="text" 
                        formControlName="facilityOrLocationName" 
                        [placeholder]="namePlaceholderText" 
                        [matAutocomplete]="locationAuto"
                        class="search-input"
                        required>
                    <mat-autocomplete #locationAuto="matAutocomplete">
                        <mat-option *ngFor="let option of filteredLocationOptions | async" [value]="option">
                            {{option}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>
            
            <div class="search-input-container">
                <div class="input-with-icon">
                    <span class="search-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.37584 4.85915C8.65549 3.61971 10.1969 3 12 3C13.8031 3 15.3372 3.61267 16.6023 4.83803C17.8675 6.06339 18.5 7.54929 18.5 9.29577C18.5 10.169 18.2746 11.169 17.8238 12.2958C17.373 13.4225 16.8277 14.4789 16.1879 15.4648C15.5481 16.4507 14.9156 17.3732 14.2903 18.2324C13.665 19.0916 13.1342 19.7746 12.698 20.2817L12 21C11.8255 20.8028 11.5928 20.5423 11.302 20.2183C11.0112 19.8944 10.4877 19.2465 9.73154 18.2746C8.97539 17.3028 8.31376 16.3592 7.74664 15.4437C7.17953 14.5282 6.66331 13.493 6.19799 12.338C5.73266 11.1831 5.5 10.169 5.5 9.29577C5.5 7.54929 6.12527 6.07043 7.37584 4.85915Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M13 9.5C13 10.0523 12.5523 10.5 12 10.5C11.4477 10.5 11 10.0523 11 9.5C11 8.94772 11.4477 8.5 12 8.5C12.5523 8.5 13 8.94772 13 9.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <input 
                        type="text" 
                        formControlName="cityOrZip" 
                        [placeholder]="cityZipPlaceholderText"
                        [matAutocomplete]="cityZipAuto"
                        class="search-input" 
                        required>
                    <mat-autocomplete #cityZipAuto="matAutocomplete">
                        <mat-option *ngFor="let option of filteredCityZipOptions | async" [value]="option">
                            {{option}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>
            
            <button 
                *ngIf="showSpinner === false"
                mat-button 
                type="submit" 
                [disabled]="!locationSearchForm.valid" 
                class="search-button">
                {{searchBtnText}}
            </button>
        </form>
        
        <div *ngIf="showSpinner === false" class="quick-search-section">
            <div *ngIf="locationQuickSearchOptions.length > 0" class="quick-search-title">{{quickSearchTitleText}}</div>
            <div class="quick-search-buttons">
                <button 
                    *ngFor="let option of locationQuickSearchOptions"
                    class="quick-search-btn" 
                    [disabled]="!locationSearchForm.get('cityOrZip')?.value"  
                    (click)="onQuickSearch(option)">
                    {{option.name}}
                </button>
            </div>
        </div>

        <div>
            <div *ngIf="showSpinner === true" class="spinner-container">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
    
    
    <!-- Need Help Deciding Card -->
    <div style="margin-top: auto;">
        <br>
        <app-need-help-deciding
            [locale]="locale">
        </app-need-help-deciding>
    </div>
    
</div>
